<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>Editar ConfigCombo</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>ConfigCombo</f7-nav-title>
      <f7-nav-title v-else sliding>Nuevo ConfigCombo</f7-nav-title>
      <f7-nav-right>
        <f7-button
          v-if="!readonly"
          fill
          icon-f7="floppy_disk"
          text="Guardar"
          class="display-flex"
          @click="$refs.rform.saveItem()"
        ></f7-button>
        <template slot="right" v-else>
          <f7-button color="blue" @click="readonly=false">{{$t('common.editar')}}</f7-button>
          <f7-button v-if="!($refs.rform && $refs.rform.formData && $refs.rform.formData.protegidoBorrado)" color="red" @click="deleteItem">{{$t('common.eliminar')}}</f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>

    <r-form
      ref="rform"
      v-slot="{rform}"
      :itemId="id"
      :beforeSave="beforeSave"
      @loadItem="loadItem"
      @save="onSave"
      :readonly="readonly"
      :dbAdapter="ConfigCombo"
      :defaultData="defaultData"
    >
      <f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="50" medium="50" small="100">
              <r-input
                outline
                class="col-100"
                :class="{'codigo-readonly': !!rform.formData.id}"
                floating-label
                label="Codigo"
                :form="rform"
                type="text"
                name="codigo"
                :readonly="rform && rform.formData && !!rform.formData.id"
                :overrideReadonly="rform && rform.formData && !!rform.formData.id"
              ></r-input>
            </f7-col>

            <f7-col width="50" medium="50" small="100">
              <r-input
                outline
                class="col-100"
                floating-label
                label="Descripcion"
                :form="rform"
                type="text"
                name="descripcion"
              ></r-input>
            </f7-col>

            <f7-col width="100" medium="100" small="100">
              <r-input
                class="col-100"
                label="Protegido contra borrado"
                :form="rform"
                type="check"
                name="protegidoBorrado"
              ></r-input>
            </f7-col>

            <f7-col width="100" medium="100" small="100" class="margin-top-half">
              <div class="display-flex justify-content-space-between align-items-center margin-bottom-half">
                <f7-block-title class="no-margin">{{$t('combos.opciones')}}</f7-block-title>
                <f7-link v-if="!readonly" @click="addValor(rform.formData)">{{$t('combos.nueva_opcion')}}</f7-link>
              </div>

              <div v-if="!rform.formData.valores || !rform.formData.valores.length" class="text-color-gray margin-bottom">
                {{$t('combos.sin_opciones')}}
              </div>

              <f7-list media-list class="no-margin">
                <Container
                  v-if="$refs.rform && $refs.rform.formData"
                  @drop="onDropValor(rform.formData.valores, $event)"
                  drag-handle-selector=".column-drag-handle"
                  lock-axis="y"
                >
                  <Draggable
                    v-for="(opcion, index) in rform.formData.valores"
                    :key="'configcombo-'+(id || 'new')+'-opcion-'+index"
                  >
                    <f7-row class="valor-row no-gap">
                      <div class="valor-controles">
                        <f7-link
                          v-if="!rform.readonly"
                          @click="deleteValor(rform.formData, index)"
                          class="margin-half valor-delete"
                          color="red"
                          icon-f7="trash"
                        ></f7-link>
                        <span
                          v-if="!rform.readonly"
                          class="column-drag-handle margin-left cursor-move col-5 valor-reordenar"
                          v-tooltip="$t('common.move')"
                        >&uarr;&darr;</span>
                      </div>

                      <r-input
                        outline
                        class="col-20 valor-codigo"
                        floating-label
                        :label="$t('combos.codigo_opcion')"
                        :form="rform"
                        type="text"
                        :name="'valores.'+index+'.valor'"
                      ></r-input>

                      <r-input
                        outline
                        class="col-40"
                        floating-label
                        :label="$t('combos.nombre_opcion')"
                        :form="rform"
                        type="text"
                        :name="'valores.'+index+'.label'"
                      ></r-input>

                      <r-input
                        outline
                        class="col-35"
                        floating-label
                        :label="$t('combos.accion_opcion')"
                        :form="rform"
                        :key="'accion-'+index+'-'+'text'"
                        :type="'text'"
                        :name="'valores.'+index+'.accion'"
                      ></r-input>

                      <div class="col-5 valor-metadatos-btn">
                        <f7-link
                          icon-f7="tag_fill"
                          :color="opcion && opcion.metadatos && Object.keys(opcion.metadatos).length ? 'blue' : 'gray'"
                          @click="openMetadatos(index)"
                          v-tooltip="opcion && opcion.metadatos && Object.keys(opcion.metadatos).length ? 'Editar metadatos JSON' : 'Añadir metadatos JSON'"
                        ></f7-link>
                      </div>
                    </f7-row>
                  </Draggable>
                </Container>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <pre style="display:none;">{{rform.formData}}</pre>

      <f7-popup
        :opened="metadatosPopupOpen"
        @popup:closed="metadatosPopupOpen = false"
        class="metadatos-popup"
      >
        <f7-page class="metadatos-popup-page">
          <f7-navbar :title="'Metadatos · ' + (metadatosPopupIndex !== null && rform.formData.valores && rform.formData.valores[metadatosPopupIndex] ? (rform.formData.valores[metadatosPopupIndex].valor || rform.formData.valores[metadatosPopupIndex].label || ('#' + (metadatosPopupIndex + 1))) : '')">
            <f7-nav-right>
              <f7-link popup-close>Cerrar</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <div class="metadatos-popup-content">
            <r-json-editor
              v-if="metadatosPopupOpen && metadatosPopupIndex !== null"
              :form="rform"
              :name="'valores.'+metadatosPopupIndex+'.metadatos'"
              :readonly="rform.readonly"
              :fill="true"
            ></r-json-editor>
          </div>
        </f7-page>
      </f7-popup>
    </r-form>
  </f7-page>
</template>

<style scoped>
.valor-row {
  position: relative;
  margin-bottom: 6px;
}
.valor-codigo {
  padding-left: 3em;
}
.valor-controles {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
}
.valor-delete {
  position: absolute;
  left: 0;
  top: 11px;
}
.valor-metadatos-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 18px;
}
.valor-reordenar {
  margin-top: 2px;
  position: absolute;
  left: 12px;
  top: 15px;
}

::v-deep .codigo-readonly .readonly .item-input-wrap input {
  background-color: #e9ecef;
}

::v-deep .metadatos-popup .page-content {
  display: flex;
  flex-direction: column;
  padding: 8px;
  box-sizing: border-box;
}
::v-deep .metadatos-popup .metadatos-popup-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
::v-deep .metadatos-popup .metadatos-popup-content > .r-json-editor {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
}
::v-deep .metadatos-popup .jsoneditor {
  border: 1px solid #d0d7de;
  height: 100% !important;
  width: 100% !important;
}
::v-deep .metadatos-popup .jsoneditor-outer {
  height: 100% !important;
}
</style>

<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rJsonEditor from "./../../components/rJsonEditor.vue";
import { Container, Draggable } from "vue-smooth-dnd";
import ConfigCombo from "./../../js/db/ConfigCombo.js";

export default {
  components: {
    rForm,
    rInput,
    rJsonEditor,
    Container,
    Draggable
  },
  data: function() {
    return {
      ConfigCombo,
      accionFocusedIndex: null,
      readonly: !this.editable,
      metadatosPopupOpen: false,
      metadatosPopupIndex: null,
      defaultData: {
        codigo: "",
        descripcion: "",
        protegidoBorrado: false,
        valores: []
      }
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setAccionFocused: function(index) {
      this.accionFocusedIndex = index;
    },
    clearAccionFocused: function(index) {
      if (this.accionFocusedIndex === index) {
        this.accionFocusedIndex = null;
      }
    },
    openMetadatos: function(index) {
      this.metadatosPopupIndex = index;
      this.metadatosPopupOpen = true;
    },
    addValor: function(combo) {
      if (!combo.valores) {
        this.$set(combo, "valores", []);
      }
      combo.valores.push({ label: "", valor: "", comentario: "" });
    },
    deleteItem: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        self.$t("common.eliminar"),
        function() {
          ConfigCombo.delete({itemId: self.id}).then(function(res) {
            if (res) {
              app.toast
                .create({
                  icon: '<i class="f7-icons">checkmark</i>',
                  text: self.$t("rlist.registro_eliminado"),
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: 2000
                })
                .open();
              self.$f7router.back();
            }
          }).catch(function(error){
            app.dialog.alert(error.message || error.error || error);
          });
        }
      );
    },
    onDropValor: function(arr, dragResult){
      this.accionFocusedIndex = null;
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;
      if (!arr) arr = [];
      var result = arr;
      let itemToAdd = payload;
      if (removedIndex !== null) {
        itemToAdd = Object.assign({}, result.splice(removedIndex, 1)[0]);
      }
      if (addedIndex !== null) {
        result.splice(addedIndex, 0, Object.assign({}, itemToAdd));
      }
    },
    deleteValor: function(combo, indexValor){
      this.accionFocusedIndex = null;
      combo.valores.splice(indexValor,1);
    },
    beforeSave: function(data, resolve, reject) {
      data.codigo = ((data && data.codigo) || "").trim();

      if (!Array.isArray(data.valores)) {
        data.valores = [];
      }

      var errors = {};

      data.valores = data.valores
        .map((v) => {
          var label = (v && (v.label || v.nombre)) || "";
          var valor = (v && v.valor) || label;
          var accion = (v && v.accion) || "";
          var nombre_valor = ((v && v.valor) || "") + ((v && v.valor && v.label)?' - ':'') + ((v && v.label) || "");
          var metadatos = (v && v.metadatos) || null;
          if (metadatos && typeof metadatos === "object" && !Array.isArray(metadatos) && Object.keys(metadatos).length === 0) {
            metadatos = null;
          }
          return { label, valor, accion, nombre_valor, metadatos };
        })
        .filter(v => v.label || v.valor || v.accion || v.metadatos);

      if (!data.codigo) {
        errors.codigo = "El campo codigo es obligatorio";
      }
      if (!data.valores.length) {
        errors.valores = "Debe anadir al menos un valor";
      }

      if (Object.keys(errors).length) {
        reject({
          message: "Revise los campos obligatorios",
          errors
        });
        return;
      }

      resolve(data);
    },
    loadItem: function(res) {
      if (!Array.isArray(res.valores)) {
        res.valores = [];
      }
      res.valores = res.valores.map(v => {
        if (typeof v === "string") {
          return { label: v, valor: v, accion: "", metadatos: null };
        }
        var label = (v && (v.label || v.nombre)) || "";
        var valor = (v && v.valor) || label;
        var accion = (v && v.accion) || "";
        var metadatos = (v && v.metadatos != null) ? v.metadatos : null;
        return { label, valor, accion, metadatos };
      });
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      self.$refs.rform.formData = res;
      self.readonly = true;
      app.toast
        .create({
          text: self.$t("common.guardado_ok") || "Guardado correctamente",
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    }
  }
};
</script>
